import { Controller } from '@hotwired/stimulus'
import Modal from "bootstrap/js/src/modal"

// usage through '_modal' partial
//   (renders automatically with 'Turbo-Frame=modal' request header)
export default class extends Controller {
  connect () {
    this._bsComponent = new Modal(this.element)
    // opens automatically when returned from server
    this._bsComponent.show()
  }

  disconnect () {
    this.hide() // hide is required to call scrollBar.reset() (#B20-824)
    this._bsComponent.dispose()
  }

  hide () {
    this._bsComponent.hide()
  }

  submitEnd (e) {
    if (e.detail.success) {
      // TODO: consider this.element.remove() - form not longer needed
      this.hide()
    }
  }
}
